module.exports = __webpack_public_path__ + "img/ico5.2811f3c5.png";